import { useState } from 'react';

// Generic keyed-list state: add/update/remove with stable _key for React rendering
export const useListState = () => {
  const [items, setItems] = useState([]);
  const add = (template) => setItems(prev => [...prev, { _key: crypto.randomUUID(), ...template }]);
  const update = (index, field, value) => setItems(prev => prev.map((it, i) => i === index ? { ...it, [field]: value } : it));
  const remove = (index) => setItems(prev => prev.filter((_, i) => i !== index));
  return [items, setItems, { add, update, remove }];
};
